import { createI18n } from 'vue-i18n' //引入vue-i18n组件
import messages from './locale/index'

const getCurrentLanguage = () => {
  //设置
  const langCode = localStorage.getItem('lang') || 'zh';
  return langCode
}
 
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getCurrentLanguage() || 'en', //去getCurrentLanguage函数找有没有设置的语言,默认选择zh
  messages: messages
})
 
export default i18n
